// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ff8mkjKS4jU0tg0LJI6xa","mainImage":"_17oaX5QmqgkGYwaFgjqBtq","number":"_2UklMVoSjJIYan_mpfmzkE"};